import Create from "./create/CreateEvent";
import Edit from "./edit/EditEvent";
import Individual from "./individual/Event";
import List from "./list/Events";
import Income from "./income";
import Cost from "./cost";

export default { 
  List, 
  Create, 
  Individual, 
  Edit,
  Income,
  Cost,
};
